import { render, staticRenderFns } from "./QcTestSettings.vue?vue&type=template&id=68759e23&scoped=true&"
import script from "./QcTestSettings.vue?vue&type=script&lang=js&"
export * from "./QcTestSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68759e23",
  null
  
)

export default component.exports